import { render, staticRenderFns } from "./Courses.html?vue&type=template&id=4202beda&external"
import script from "./Courses.js?vue&type=script&lang=js&external"
export * from "./Courses.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports